export async function copyTextToClipboard(text: string): Promise<boolean> {
  if (
    typeof navigator !== 'undefined' &&
    navigator.clipboard !== undefined &&
    typeof navigator.clipboard.writeText === 'function'
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (clipboardError) {
      void clipboardError;
    }
  }
  return copyUsingSelectionFallback(text);
}

function copyUsingSelectionFallback(text: string): boolean {
  if (typeof document === 'undefined') {
    return false;
  }
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.opacity = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  textArea.setSelectionRange(0, text.length);
  let didCopy = false;
  try {
    didCopy = document.execCommand('copy');
  } catch (fallbackError) {
    void fallbackError;
    didCopy = false;
  }
  document.body.removeChild(textArea);
  return didCopy;
}
